"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArrayNestedField = exports.useNestedField = exports.useField = exports.useFormContext = exports.FormProvider = void 0;
const react_1 = __importStar(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const lodash_1 = require("lodash");
const FormContext = react_1.default.createContext({});
const FormProvider = (props) => {
    return (0, react_1.createElement)(FormContext.Provider, props, props.children);
};
exports.FormProvider = FormProvider;
function useFormContext() {
    return (0, react_1.useContext)(FormContext);
}
exports.useFormContext = useFormContext;
function useField(name) {
    const { values, onChange } = useFormContext();
    return [
        values[name],
        (nextValue) => {
            onChange(Object.assign(Object.assign({}, values), { [name]: nextValue }));
        },
    ];
}
exports.useField = useField;
function useNestedField(path) {
    const { values, onChange } = useFormContext();
    const currentValue = (0, get_1.default)(values, path);
    const handleChange = (nextValue) => {
        const updatedValues = (0, cloneDeep_1.default)(values);
        (0, lodash_1.set)(updatedValues, path, nextValue);
        onChange(updatedValues);
    };
    return [currentValue, handleChange];
}
exports.useNestedField = useNestedField;
function useArrayNestedField(name, parentName, childIndex) {
    const { values, onChange } = useFormContext();
    if (typeof childIndex !== 'undefined' && parentName) {
        const parent = values[parentName];
        const value = parent[childIndex][name];
        return [
            value,
            (nextValue) => {
                const nextParent = parent.map((parentItem, index) => {
                    return index === childIndex
                        ? Object.assign(Object.assign({}, parentItem), { [name]: nextValue }) : parentItem;
                });
                onChange(Object.assign(Object.assign({}, values), { [parentName]: nextParent }));
            },
        ];
    }
    else {
        return [
            values[name],
            (nextValue) => {
                onChange(Object.assign(Object.assign({}, values), { [name]: nextValue }));
            },
        ];
    }
}
exports.useArrayNestedField = useArrayNestedField;
//# sourceMappingURL=FormContext.js.map